import { render, staticRenderFns } from "./CustomerGrid.vue?vue&type=template&id=88c43e72"
import script from "./CustomerGrid.vue?vue&type=script&lang=js"
export * from "./CustomerGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports